import { uniqueKey } from 'global/common/keys';
import React, { useMemo } from 'react'
import { Label } from 'semantic-ui-react'

export const SectionDateHeader = ({
  levelKey,
  startDate,
  matches: matches_date,
  showMissingMatches,
  handleShowMissingMatches,
  attachRef,
  levelDateRef,
}) => {

  const counts = useMemo(() => {
    const allMatches = _.flatMap(matches_date ?? {}, matches => matches);
    const total = _.size(allMatches);
    const completed = _.filter(allMatches, (m) => !!m?.results).length;
    const matchDay = _.filter(allMatches, (m) => !!m?._results_matchDay).length;
    const missing = _.filter(allMatches, (m) => !!m?._status?.isMissing).length;
    return { total, completed, missing, matchDay }; s
  }, [matches_date]);

  const header = useMemo(() => {
    return <div className={`match-date-header header-flex ${attachRef ? 'arf' : ''}`}
      key={uniqueKey('sdh', levelKey, startDate)}
      ref={el => {
        if (attachRef && el) {
          levelDateRef.current[levelKey] = el
        }
      }}
    >
      <div className='hi-center'>{startDate}</div>
      <div className='hi-right'>
        {counts.matchDay > 0 && <Label size='tiny' className={'rmd'} title='Match Day'>{counts.matchDay}</Label>}
        {counts.missing > 0 && <Label size='tiny' className={showMissingMatches ? 'miss-o' : 'miss'} title='Missing' onClick={() => { handleShowMissingMatches() }}>{counts.missing}</Label>}
        <Label size='tiny' color='black' title={'Total'}>{counts.total}</Label>
      </div>
    </div>
  }, [startDate, counts])

  return header

}
